module.exports = __webpack_public_path__ + "static/media/tele5.f19d045c.svg";